module.exports = __webpack_public_path__ + "img/thumb7.b444cce1.png";